<template>
    <div class="txt-cent">
        <div class="tit-cent">{{ data.title }}<i class="ico-que" @mouseover="mouseoverHandle" @mouseleave="mouseleaveHandle"></i></div>
        <div v-show="isShowTips" class="bubble-fff-tip bubble-top" style=" top:-58px;width: 200px;left: 8px;">
            {{ data.tips }}
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "TitleBase",
    props: ["data"],
    data() {
        return {
            isShowTips: false
        };
    },
    methods: {
        mouseoverHandle() {
            this.isShowTips = true;
        },
        mouseleaveHandle() {
            this.isShowTips = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.txt-cent {
    margin-bottom: 16px;
    padding: 24px 0;
    position: relative;
    border: 1px solid #d9e4ef;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    background: #fff;
    div:last-child {
        &::after {
            display: none;
        }
    }
    .tit-cent {
        position: absolute;
        left: 20px;
        top: 12px;
        font-weight: bold;
        font-size: 14px;

        .ico-que {
            display: inline-block;
            background: url($zhijiStaticImagePath+"model-spr.png") no-repeat;
            width: 18px;
            height: 18px;
            background-position: -179px -42px;
            margin-left: 6px;
            vertical-align: -4px;
        }
    }

    .bubble-fff-tip {
        position: absolute;
        background: #fff;
        border: 1px solid #d9e4ef;
        border-radius: 4px;
        padding: 10px;
        width: 324px;
        font-size: 12px;
        box-shadow: 0px 3px 6px #e0e2e4;
        z-index: 11;

        &:before {
            position: absolute;
            left: -14px;
            width: 15px;
            height: 21px;
            top: 50%;
            margin-top: -12px;
            display: inline-block;
            content: "";
            background: url($zhijiStaticImagePath+"white-jt.png") no-repeat;
            background-size: 100% 100%;
        }
    }

    .bubble-top:before {
        position: absolute;
        bottom: -20px;
        top: auto;
        width: 21px;
        height: 20px;
        left: 0;
        right: 0;
        margin: 0 auto;
        margin-top: -12px;
        display: inline-block;
        content: "";
        background: url($zhijiStaticImagePath+"white-jt-bottom.png") no-repeat;
        background-size: 100% 100%;
    }
}
</style>
